var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"marker-container",on:{"click":_vm.onClick}},[_c('div',{staticClass:"marker",class:{included: _vm.included, interactive: _vm.interactive, small: !_vm.terminal}})])}
var staticRenderFns = []

export { render, staticRenderFns }